<template>
  <WdsAlert
    :success="variant === 'success'"
    :info="variant === 'info'"
    :warning="variant === 'warning'"
    bordered
    class="tw-mb-3"
  >
    <WdsStack direction-column gap-sm>
      <WdsStack direction-row gap-sm justify-space-between align-center>
        <WdsStack direction-row gap-sm align-center>
          <WdsAvatar v-if="avatarUrl" :path="avatarUrl" sm />
          <WdsStack direction-column>
            <WdsStack direction-row gap-sm align-center>
              <span class="tw-font-bold">{{ message }}</span>
              <WdsTag v-if="tag" sm error data-test="source-link-banner-tag">{{ tag }}</WdsTag>
            </WdsStack>
            <span v-if="subtitle" class="tw-text-gray-600">{{ subtitle }}</span>
            <WdsStack v-if="details.length > 0" direction-row gap-md class="tw-text-md">
              <span v-for="(detail, index) in details" :key="index">{{ detail }}</span>
            </WdsStack>
            <span v-if="body" class="tw-mt-2" data-test="source-link-banner-body">{{ body }}</span>
          </WdsStack>
        </WdsStack>
        <WdsButton
          v-if="linkUrl"
          :href="linkUrl"
          :success-subtle="variant === 'success'"
          :info-subtle="variant === 'info'"
          small
        >
          {{ linkText }}
        </WdsButton>
      </WdsStack>
    </WdsStack>
  </WdsAlert>
</template>

<script lang="ts" setup>
import { WdsAlert, WdsAvatar, WdsButton, WdsStack, WdsTag } from '@worksome/wds-components'

withDefaults(
  defineProps<{
    message: string
    subtitle?: string
    avatarUrl?: string
    details?: string[]
    linkUrl?: string
    linkText?: string
    tag?: string
    body?: string
    variant?: 'success' | 'info' | 'warning'
  }>(),
  {
    details: () => [],
    variant: 'success',
  },
)
</script>
